// extracted by mini-css-extract-plugin
export default {"navLink":"SidebarLink_navLink__+ov3Z","active":"SidebarLink_active__ewOfe"};